import ButtonLargeMixin from './mixins/button-large-mixin.js';
import ButtonCtaMixin from './mixins/button-cta-mixin.js';
import ButtonShadow from './mixins/button-shadow-mixin.js';
import TpButton from './tp-button.js';

class TpButtonCtaLarge extends 
  ButtonLargeMixin(
  ButtonCtaMixin(
  ButtonShadow(
    TpButton
  ))) {}

export default TpButtonCtaLarge;


